<template>
    <div>
        <ion-card class="-light">
            <ion-list-header>Persönliche Daten</ion-list-header>
            <ion-grid>
                <ion-row>
                    <ion-col size="12" size-md="6">
                        <base-select
                            :value="geschlecht"
                            @input="$emit('update:geschlecht', $event)"
                            :label="'Anrede' + suffix"
                            id="geschlecht"
                            :hasInputErrorField="hasInputErrorFields"
                        >
                            <ion-select-option value="Frau"
                                >Frau</ion-select-option
                            >
                            <ion-select-option value="Herr"
                                >Herr</ion-select-option
                            >
                        </base-select>
                    </ion-col>
                    <ion-col size="12" size-md="6">
                        <base-input
                            id="titel"
                            type="text"
                            :value="titel"
                            label="Titel"
                            @input="$emit('update:titel', $event)"
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12" size-md="6">
                        <base-input
                            id="vorname"
                            type="text"
                            :value="vorname"
                            :label="'Vorname' + suffix"
                            @input="$emit('update:vorname', $event)"
                            :hasInputErrorField="hasInputErrorFields"
                        ></base-input>
                    </ion-col>
                    <ion-col size="12" size-md="6">
                        <base-input
                            id="zuname"
                            type="text"
                            :value="zuname"
                            :label="'Nachname' + suffix"
                            @input="$emit('update:zuname', $event)"
                            :hasInputErrorField="hasInputErrorFields"
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <base-datetime
                            :label="'Geburtsdatum' + suffix"
                            :value="geburtsdatum"
                            id="geburtsdatum"
                            @input="$emit('update:geburtsdatum', $event)"
                            :hasInputErrorField="hasInputErrorFields"
                        ></base-datetime>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <ion-card class="-light">
            <ion-list-header>Adresse</ion-list-header>
            <ion-grid>
                <ion-row>
                    <ion-col size="8">
                        <base-input
                            id="strasse"
                            type="text"
                            :value="strasse"
                            :label="'Straße' + suffix"
                            @input="$emit('update:strasse', $event)"
                            :hasInputErrorField="hasInputErrorFields"
                        ></base-input>
                    </ion-col>
                    <ion-col size="4">
                        <base-input
                            id="hausnr"
                            type="text"
                            :value="hausnr"
                            :label="'Hausnr.' + suffix"
                            @input="$emit('update:hausnr', $event)"
                            :hasInputErrorField="hasInputErrorFields"
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="4">
                        <base-input
                            id="stiege"
                            type="text"
                            :value="stiege"
                            label="Stiege"
                            @input="$emit('update:stiege', $event)"
                        ></base-input>
                    </ion-col>
                    <ion-col size="4">
                        <base-input
                            id="stock"
                            type="text"
                            :value="stock"
                            label="Stock"
                            @input="$emit('update:stock', $event)"
                        ></base-input>
                    </ion-col>
                    <ion-col size="4">
                        <base-input
                            id="tuer"
                            type="text"
                            :value="tuer"
                            label="Tür"
                            @input="$emit('update:tuer', $event)"
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12" size-md="2">
                        <base-input
                            id="plz"
                            type="number"
                            inputmode="decimal"
                            :value="plz"
                            :label="'PLZ' + suffix"
                            @input="$emit('update:plz', $event)"
                            :hasInputErrorField="hasInputErrorFields"
                        ></base-input>
                    </ion-col>
                    <ion-col size="12" size-md="10">
                        <base-input
                            id="ort"
                            type="text"
                            :value="ort"
                            :label="'Ort' + suffix"
                            @input="$emit('update:ort', $event)"
                            :hasInputErrorField="hasInputErrorFields"
                        ></base-input>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <ion-card class="-light">
            <ion-list-header>Kontakt</ion-list-header>
            <ion-grid>
                <ion-row>
                    <ion-col size="12" size-md="6">
                        <base-input
                            id="email"
                            type="email"
                            :value="email"
                            :label="'E-Mail' + suffix"
                            @input="$emit('update:email', $event)"
                            :hasInputErrorField="hasInputErrorFields"
                        ></base-input>
                    </ion-col>
                    <ion-col size="12" size-md="6">
                        <base-input
                            id="telefon"
                            type="tel"
                            :value="telefon"
                            :label="'Telefonnummer' + suffix"
                            @input="$emit('update:telefon', $event)"
                            :hasInputErrorField="hasInputErrorFields"
                        ></base-input>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
    </div>
</template>

<script>
import BaseInput from "./BaseInput";
import BaseSelect from "./BaseSelect";
import BaseDatetime from "./BaseDatetime";

export default {
    components: {
        BaseSelect,
        BaseInput,
        BaseDatetime,
    },
    props: {
        geschlecht: {
            required: true,
            type: String,
        },
        titel: {
            required: true,
            type: String,
        },
        vorname: {
            required: true,
            type: String,
        },
        zuname: {
            required: true,
            type: String,
        },
        strasse: {
            required: true,
            type: String,
        },
        hausnr: {
            required: true,
            type: String,
        },
        stiege: {
            required: true,
            type: String,
        },
        stock: {
            required: true,
            type: String,
        },
        tuer: {
            required: true,
            type: String,
        },
        plz: {
            required: true,
            type: String,
        },
        ort: {
            required: true,
            type: String,
        },
        email: {
            required: true,
            type: String,
        },
        telefon: {
            required: true,
            type: String,
        },
        geburtsdatum: {
            required: true,
            type: String,
        },
        suffix: {
            required: false,
            type: String,
            default: "",
        },
        hasInputErrorFields: {
            required: false,
            type: Boolean,
            default: true,
        },
    },
    methods: {},
};
</script>

<style></style>
